import React, { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router'
import { firestore, removeFile, storage } from '../../../firebase/firebase'
import UserCard from '../../components/Users/UserCard'
import { makeStyles, Grid, Snackbar, Button } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useAuth } from '../../../providers/AuthContext';
import MyUserCard from '../../components/Users/MyUserCard';
import { useUnitDescription } from '../../../providers/UnitDescriptionContext';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex', 
        width:'100%', 
        padding: '32px', 
        marginBottom:'30px',
        justifyContent:'center',
        marginTop: '40px',
    },
}));

const User = (props) =>  {
    const classes = useStyles();
    const {userInfo} = useAuth();
    const { units, unitLoading, getUnits } = useUnitDescription();

    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);
    const [saveState, setSaveState] = useState({});
    const [deleting, setDeleting] = useState(false);
    const [roles, setRoles] = useState([]);
    const [rolesLoading, setRolesLoading] = useState(true);

    //FOR TESTING PURPOSES
    useEffect(() => {
        console.log('userData', userData)
    }, [userData])

    const me = (props.location.pathname === '/dashboard/users/me')
    let path = me?userInfo.docId:new URLSearchParams(props.location.search).get("docId");

    //gets inital info
    useEffect(() => {
        try{
            getUnits()

            setRolesLoading(true);
            firestore.collection('roles').get()
                .then(querySnapshot => {
                    setRoles(querySnapshot.docs.map((doc) => {
                    return {
                        ...doc.data(),
                        'docId': doc.id,
                    }
                    }))
                    setRolesLoading(false);

                    firestore.collection('users').where('__name__', "==", path).get()
                    .then(querySnapshot => {
                        const userResponse = querySnapshot.docs.map((doc) => {
                            return {
                                ...doc.data(),
                                'docId': path,
                                'department': doc.data().department ? doc.data().department : 'None',
                                'role': doc.data().role ? doc.data().role : doc.data().admin ? 'Admin' : '',
                                'address': doc.data().address ?  doc.data().address : {
                                    'street': doc.data().address?.street ? doc.data().address.street : "123 Street Way", 
                                    'city': doc.data().address?.city ? doc.data().address.city : "Winnipeg",
                                    'province': doc.data().address?.province ? doc.data().address.province : 'Manitoba',
                                    'postalCode': doc.data().address?.postalCode ? doc.data().address.postalCode : 'R2C 1B2',
                                },
                                'birthday': doc.data().birthday  ?  doc.data().birthday : '1990/01/01',
                                'phone': doc.data().phone ? doc.data().phone : '',
                                'employment': doc.data().employment ?  doc.data().employment : {
                                    'startDate': doc.data().employment?.startDate ? doc.data().employment.startDate : '1990/01/01',
                                    'active': true,
                                    'endDate': doc.data().employment?.endDate ? doc.data().employment.endDate : 'Still Employed',
                                    'type': 'Employee',
                                    'wcbNum': '',
                                    'gstNum': '',
                                },
                                'firstName': doc.data().firstName ? doc.data().firstName : doc.data().displayName.substring(0, doc.data().displayName.indexOf(" ")),
                                'lastName': doc.data().lastName ? doc.data().lastName : doc.data().displayName.substring(doc.data().displayName.indexOf(" ")+1),
                                'payroll': {
                                    ...doc.data().payroll,
                                    'class': doc.data().payroll?.class ? doc.data().payroll?.class : "Employee",
                                    'payRate': doc.data().payroll?.payRate ? doc.data().payroll?.payRate : '0.00',
                                    'percentagePayRate': doc.data().payroll?.percentagePayRate ? doc.data().payroll?.percentagePayRate : '0.00',
                                    'getsPremiumRate': doc.data().payroll?.getsPremiumRate ? doc.data().payroll?.getsPremiumRate : false,
                                },
                                'contacts': doc.data().contacts ? doc.data().contacts : [
                                    { 'id': 0, 'name': 'Sample Contact', 'phone': '000-000-0000', 'description': 'Home', 'email': 'emailaddress@email.ca'  },
                                ],
                                'medical': doc.data().medical ? doc.data().medical : [
                                    { 'id': 0, 'name': 'Sample Medicine/Allergy', 'details': '', },
                                ],
                                'notes': doc.data().notes ? doc.data().notes : '',
                                'commonEquipment': doc.data().commonEquipment ? doc.data().commonEquipment : {},
                                'mfaType': doc.data().mfaType ? doc.data().mfaType : 'Email',
                                'totp': doc.data().totp ? doc.data().totp : {
                                    'enabled': false,
                                    'verified': false,
                                    'ascii': '',
                                    'hex': '',
                                    'base32': '',
                                    'auth_url': '',
                                },
                                'driversLicenseNum': doc.data().driversLicenseNum ? doc.data().driversLicenseNum : '',
                                'driversLicenseType': doc.data().driversLicenseType ? doc.data().driversLicenseType : '',
                            }
                        })
                        setUserData(userResponse[0]);
                        setSaveState(userResponse[0]);
                        firestore.collection('users').doc(path)
                            .update(userResponse[0])
                        setLoading(false);
                    })
            })
        }
        catch (e){
            setRolesLoading(false);
            setError("User not found.");
            console.warn(e.message);
        }
    }, [path]);

    const updateUserData = useCallback((e) => {
            setUserData(e)
        },
        [],
    );

    const updateUserAndSaveData = useCallback((e) => {
            setUserData(e)
            setSaveState(e)
        },
        [],
    );

    const confirmSave = () => {
        setSaving(true);
        firestore.collection('users').doc(me?userInfo.docId:path)
            .update(userData)
            .then(() => {
                setSaveState(userData);
                setSaving(false)
            })
            .catch((e) => setError(e));
    };

    const cancelSave = () => {
        setUserData(saveState);
    };

    const handleDeleteUser  = async () => {
        setDeleting(true)
        if(userData.driversFrontURL !== "" || userData.driversFrontURL !== null)
        {
            await removeFile(userData.driversFrontURL);
        }
        if(userData.driversBackURL !== "" || userData.driversBackURL !== null)
        {
            await removeFile(userData.driversBackURL);
        }
        firestore.collection('users').doc(userData.docId).delete().then(() => {
            //* need delete photos
            firestore.collection('timesheets').where('uid', '==', userData.uuid).get().then((docs) => docs.forEach((doc) => firestore.collection('timesheets').doc(doc.id).delete()))
            firestore.collection('jobs').where('uid', '==', userData.uuid).get().then((docs) => docs.forEach((doc) => firestore.collection('jobs').doc(doc.id).delete().then(() => {
                if(doc.data().photoURLs.length > 0)
                {
                    doc.data().photoURLs.map((photo) => removeFile(photo));
                }
            })))
            firestore.collection('units').where('uid', '==', userData.uuid).get().then((docs) => docs.forEach((doc) => firestore.collection('units').doc(doc.id).delete().then(() => {
                if(doc.data().photoURLs.length > 0)
                {
                    doc.data().photoURLs.map((photo) => removeFile(photo));
                }
            })))
            firestore.collection('deliveries').where('uid', '==', userData.uuid).get().then((docs) => docs.forEach((doc) => firestore.collection('deliveries').doc(doc.id).delete().then(() => {
                if(doc.data().photoURLs.length > 0)
                {
                    doc.data().photoURLs.map((photo) => removeFile(photo));
                }
            })))
            firestore.collection('defectReports').where('uid', '==', userData.uuid).get().then((docs) => docs.forEach((doc) => firestore.collection('defectReports').doc(doc.id).delete().then(() => {
                if(doc.data().photoURLs.length > 0)
                {
                    doc.data().photoURLs.map((photo) => removeFile(photo));
                }
            })))
            firestore.collection('checklists').where('uid', '==', userData.uuid).get().then((docs) => docs.forEach((doc) => firestore.collection('checklists').doc(doc.id).delete().then(() => {
                if(doc.data().photoURLs.length > 0)
                {
                    if(doc.data().photoURLs?.damage)
                        removeFile(doc.data().photoURLs.damage);
                    else if(doc.data().photoURLs?.inaccessible)
                        removeFile(doc.data().photoURLs.inaccessible);
                }
            })))
            firestore.collection('covid').where('uid', '==', userData.uuid).get().then((docs) => docs.forEach((doc) => firestore.collection('covid').doc(doc.id).delete()))
            setDeleting(false)
            console.log("User successfully deleted!");
            props.history.replace({pathname: '/dashboard/users'})
        }).catch((error) => {
            setDeleting(false)
            console.error("Error removing user: ", error);
        });
        
    }
    
    return (
        <Grid>
            {loading || deleting
            ? 
            <Grid className={classes.content}>
                <Skeleton variant='rect' width={'50vw'} height={'85vh'}/>
            </Grid>
            : 
            <Grid>
                {!me?
                <UserCard 
                    error={error} 
                    setUserData={setUserData}
                    userData={userData} 
                    saveState={saveState}   
                    setSaveState={setSaveState}
                    cancelSave={cancelSave} 
                    confirmSave={confirmSave} 
                    updateUserData={updateUserData} 
                    saving={saving}
                    handleDeleteUser={handleDeleteUser} 
                    me={me}
                    roles={roles}
                    rolesLoading={rolesLoading}
                    units={units}
                    unitLoading={unitLoading}
                    updateUserAndSaveData={updateUserAndSaveData}
                /> 
                :
                <MyUserCard
                    error={error} 
                    setUserData={setUserData}
                    userData={userData} 
                    saveState={saveState}   
                    setSaveState={setSaveState}
                    cancelSave={cancelSave} 
                    confirmSave={confirmSave} 
                    updateUserData={updateUserData} 
                    saving={saving}
                    handleDeleteUser={handleDeleteUser} 
                    me={me}
                    roles={roles}
                    rolesLoading={rolesLoading}
                    units={units}
                    unitLoading={unitLoading}
                    updateUserAndSaveData={updateUserAndSaveData}
                />
                }
            </Grid> 
            }
              
            <Snackbar
                open={!_.isEqual(userData, saveState)}
                message={saving ? 'Saving...' : 'Save Document?'}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                action={
                    <React.Fragment>
                        {saving
                            ? null
                            : <React.Fragment>
                                <Button variant='text' color='primary' onClick={cancelSave} style={{ marginLeft: '32px', marginRight: '8px' }}>Cancel</Button>
                                <Button variant='contained' onClick={confirmSave}>Confirm</Button>
                            </React.Fragment>}
                    </React.Fragment>
                } 
            />
        </Grid>
    )
}

export default withRouter(User);